import { type DropdownOption } from "~/services/cms/models/formElements/StrapiDropdown";

export const dynamicSelectZodDescription = "dynamic_select";

export type DynamicOptions = Record<string, DropdownOption[]>;
